import IDataSelect from "../../shared/interfaces/select.interface";

export const SELECT_DATA: IDataSelect = {
	id: 'branch',
    color: 'error',
    label: false,
    textLabel: "Continuar",
    size:'large',
    value: '',
    items: [],
}

export const SELECT_LIST_RESPONSIVE: IDataSelect = {
	id: 'menuResponsive',
    color: 'standard',
    label: true,
    textLabel: "Opciones",
    size:'large',
    value: '0',
    items: [],
}

export const SELECT_LIST = [
    { id: 0, text: 'Clases', name: 'Clases', class: `list-item`, icon: 'bar-gym', 'iconWidth': 30, 'iconHeight': 30, 'iconHeightMobile': 21 },
    { id: 1, text: 'Asistencia pendiente', name: 'Asistencia pendiente', class: 'list-item', icon: 'pending', 'iconWidth': 30, 'iconHeight': 30, 'iconHeightMobile': 30 },
    { id: 2, text: 'Historial', name: 'Historial', class: 'list-item', icon: 'history', 'iconWidth': 22, 'iconHeight': 22, 'iconHeightMobile': 22 },
    { id: 3, text: 'Reportes', name: 'Reportes', class: 'list-item', icon: 'report', 'iconWidth': 25, 'iconHeight': 25, 'iconHeightMobile': 25 },
    // { id: 4, text: 'Horarios', class: 'list-item', icon: '', 'iconWidth': 30, 'iconHeight': 30, 'iconHeightMobile': 30 },
    { id: 4, text: 'Comentarios', name: 'Comentarios', class: 'list-item', icon: 'comments', 'iconWidth': 22, 'iconHeight': 22, 'iconHeightMobile': 22 },
]